var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoLimits24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_limits24x24",
    transform: "translate(-2.1 -2.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fence",
    d: "M20.032,4.529,18.591,2.548a.677.677,0,0,0-.991-.172c-.09.086-.18.086-.18.172L15.977,4.529c-.09.086-.09.258-.09.431V6.683H13.274V4.96a.748.748,0,0,0-.09-.431L11.742,2.548a.677.677,0,0,0-.991-.172c-.09.086-.18.086-.18.172L9.129,4.529a.748.748,0,0,0-.09.431V6.683H6.425V4.96a.748.748,0,0,0-.09-.431L4.893,2.548a.992.992,0,0,0-1.081-.172.19.19,0,0,1-.18.172L2.28,4.529c-.09.172-.18.258-.18.431V17.536a.7.7,0,0,0,.721.689H5.614a.7.7,0,0,0,.721-.689V16.158H8.949v1.378a.7.7,0,0,0,.721.689h2.793a.7.7,0,0,0,.721-.689V16.158H15.8v1.378a.7.7,0,0,0,.721.689h2.793a.7.7,0,0,0,.721-.689V4.96A.377.377,0,0,0,20.032,4.529Zm-10.994,9.3H6.425V9.095H9.039Zm4.235-4.824h2.613v4.738H13.274Z",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoLimits24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_limits24x24.d09000a8fb86df3b19cbb9cde36d3b01.svg";